module.exports = __webpack_public_path__ + "img/sword-gold.0e63caca.svg";